// services/tables.js
import { getSubdomain, fetchWithAuth } from "../helpers";
import { API_PASSWORD } from "../config";


export async function fetchNotifications(token) {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/my/notifications?api_password=${API_PASSWORD}`;
  const res = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });
  if (!res.ok) throw new Error("فشل في جلب الإشعارات");
  const data = await res.json();
  return data;
}


export async function markNotificationsAsSeen(token, notificationsId = []) {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/see/notifications/?api_password=${API_PASSWORD}`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ notificationsId }),
  });
  if (!res.ok) throw new Error("فشل في تعليم الإشعارات كمقروءة");
  return await res.json();
}

